import type { BaseUsecase } from '@usecases/base-usecase';

export type SetOutboundNumberRequest = {
  number: string;
  id: number;
};

export interface SetOutboundNumberRepository {
  updateNumber(number: string, id: number): Promise<void>;
}

export interface SetOutboundNumberUsecase
  extends BaseUsecase<SetOutboundNumberRequest, void> {
  run(req: SetOutboundNumberRequest): Promise<void>;
}

export class SetOutboundNumber implements SetOutboundNumberUsecase {
  constructor(private repository: SetOutboundNumberRepository) {}

  async run({ number, id }: SetOutboundNumberRequest): Promise<void> {
    this.repository.updateNumber(number, id);
  }
}
